// extracted by mini-css-extract-plugin
export default {"prompt":"style_prompt__YKoJx","modal-buttons":"style_modal-buttons__RHLj3","modalButtons":"style_modal-buttons__RHLj3"};